import ProtvistaMSA from "./protvista-msa";

if (window.customElements) {
  customElements.define("protvista-msa", ProtvistaMSA);
}
export default ProtvistaMSA;
